import { Injectable } from '@angular/core';
import { BehaviorSubject, take } from 'rxjs';
import {
  BillingCycleLimitModel,
  SmsPhoneNumberModel,
  ReportRequest,
  SummaryByDayReportModel,
  SummaryKeywordsReportModel,
  SummaryReportModel,
  TopNumbersReportModel,
  LookupModel,
} from '../api/models';
import { AdvancedMessagingService as AdvancedMessagingService } from '../api/services/advanced-messaging.service';
import { LookupService } from '../api/services';

@Injectable()
export class ProMessagingReportsService {
  public summaryList = new BehaviorSubject<SummaryReportModel>(null);
  public summaryListByDay = new BehaviorSubject<Array<SummaryByDayReportModel>>([]);
  public summaryListByPhoneNumber = new BehaviorSubject<Array<TopNumbersReportModel>>([]);
  public summaryListByKeywords = new BehaviorSubject<Array<SummaryKeywordsReportModel>>([]);
  public messagingPhoneNumbers = new BehaviorSubject<Array<SmsPhoneNumberModel>>([]);
  public messagingUserEmails = new BehaviorSubject<Array<LookupModel>>([]);

  constructor(
    private messagingReportsController: AdvancedMessagingService,
    private lookupService: LookupService,
  ) {}

  async getSummaryList(state: ReportRequest): Promise<void> {
    const response = await this.messagingReportsController
      .proMessagingReportsSummaryReport({ body: state })
      .toPromise();

    this.summaryList.next(response);
  }

  async getSummaryKeywordsList(state: ReportRequest): Promise<void> {
    console.log(state);
    const response = await this.messagingReportsController
      .proMessagingReportsSummaryKeywordsReport({ body: state })
      .toPromise();

    this.summaryListByKeywords.next(response);
  }

  async getSummaryListByDay(state: ReportRequest): Promise<void> {
    console.log(state);
    const response = await this.messagingReportsController
      .proMessagingReportsSummaryReportByDay({ body: state })
      .toPromise();

    this.summaryListByDay.next(response);
  }

  async getSummaryListByPhoneNumber(state: ReportRequest): Promise<void> {
    console.log(state);
    const response = await this.messagingReportsController
      .proMessagingReportsGetTopNumbersReport({ body: state })
      .toPromise();

    this.summaryListByPhoneNumber.next(response);
  }

  async getMessagingLimits(): Promise<BillingCycleLimitModel> {
    const response = await this.messagingReportsController.proMessagingGetMessagingLimits().toPromise();
    return response.data;
  }

  getMyMessagingPhoneNumbers(): void {
    this.messagingReportsController
      .proMessagingReportsGetMyMessagingPhoneNumbers()
      .pipe(take(1))
      .subscribe(response => {
        this.messagingPhoneNumbers.next(response || []);
      });
  }

  getMessagingUserEmails(): void {
    this.lookupService
      .lookupGetCustomerUserEmails({ onlySms: true })
      .pipe(take(1))
      .subscribe(gridRes => {
        this.messagingUserEmails.next(gridRes?.data || []);
      });
  }
}
